export const UploadEvent = {
  Upload: 'upload'
};